import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, Block } from "jsxstyle";
import { faTh, faBell, faUser } from "@fortawesome/pro-solid-svg-icons";
import * as ReactDOM from "react-dom";
import { Applications } from "./Applications";
import { Overlay } from "react-overlays";
import { SemiBold } from "./Styling";

interface OverlayInjectedProps {
    style?: React.CSSProperties;
}

const Popover: React.SFC<OverlayInjectedProps> = ({ children, style }) => (
    <Col
        style={style}
        position="absolute"
        border="10px solid #D8D7D7"
        backgroundColor="white"
    >
        {children}
    </Col>
);

export interface MenuItemProps {
    icon: any;
    text: string;
    onClick: () => void;
}

export const MenuItem: React.SFC<MenuItemProps> = ({ icon, text, onClick }) => {
    return (
        <Row
            props={{ onClick }}
            cursor="pointer"
            padding={10}
            backgroundColor="white"
        >
            <FontAwesomeIcon icon={icon} />
            <Block marginLeft={5}>{text}</Block>
        </Row>
    );
};

class Menu extends React.Component<OverlayInjectedProps, {}> {
    render() {
        return (
            <Popover style={this.props.style}>{this.props.children}</Popover>
        );
    }
}

const AppsOverlay = ({ applications, style }: any) => (
    <Popover style={style}>
        <Block padding={10}>
            <Applications applications={applications} mode="small" />
        </Block>
    </Popover>
);

const Logo = (props: any) => (
    <Block
        component="img"
        props={{ src: "img/monogram.png" }}
        width={40}
        height={40}
    />
);

const headerIconWidth = 40;

class HeaderIcon extends React.Component<any, {}> {
    render() {
        const { icon, onClick, active, enabled } = this.props;
        let style = {
            backgroundColor: active ? "#D8D7D7" : "inherit",
            color: enabled ? "inherit" : "#D8D8D8"
        };
        return (
            <Col
                alignSelf="stretch"
                justifyContent="center"
                width={headerIconWidth}
                cursor="pointer"
                padding="0 10px"
                fontSize={19}
                props={{ onClick: onClick }}
                style={style}
            >
                <FontAwesomeIcon icon={icon} />
            </Col>
        );
    }
}

export interface HeaderProps {
    appName: string;
    applications: any[];
    notifications: any[];
    menuItems: any[];
    showMenu: boolean;
    showApps: boolean;
}

export interface HeaderEvents {
    onAccountIconClick: () => void;
    onAppsIconClick: () => void;
}

export class Header extends React.Component<HeaderProps & HeaderEvents, {}> {
    appsIcon: any;
    notificationsIcon: any;
    accountIcon: any;
    renderNotificationsOverlay() {
        let note = this.props.notifications[0];
        return (
            <Overlay
                show={note != null}
                placement={"bottom"}
                container={this}
                target={this.findNotificationsIcon}
                shouldUpdatePosition={true}
            >
                <Popover style={{ width: 400 }}>{note}</Popover>
            </Overlay>
        );
    }
    render() {
        // make sure the title ends up in the middle of the header by using the same width
        // for the left and right content
        let leftWidthAdjustment = headerIconWidth * 3;
        return (
            <Row
                justifyContent="space-between"
                alignItems="center"
                backgroundColor="#EBEBEB"
                height={40}
                position="relative"
            >
                <Row width={leftWidthAdjustment}>
                    <Logo />
                </Row>
                <Row>
                    <SemiBold>{this.props.appName}</SemiBold>
                </Row>
                <Row height="100%" alignItems="center">
                    <HeaderIcon
                        ref={el => (this.appsIcon = el)}
                        active={this.props.showApps}
                        enabled={true}
                        icon={faTh}
                        onClick={this.props.onAppsIconClick}
                    />
                    <HeaderIcon
                        ref={el => (this.notificationsIcon = el)}
                        active={this.props.notifications.length > 0}
                        enabled={this.props.notifications.length > 0}
                        icon={faBell}
                    />
                    <HeaderIcon
                        ref={el => (this.accountIcon = el)}
                        active={this.props.showMenu}
                        enabled={true}
                        icon={faUser}
                        onClick={this.props.onAccountIconClick}
                    />
                </Row>
                <Overlay
                    show={this.props.showMenu}
                    placement={"bottom"}
                    container={this}
                    target={this.findMenuIcon}
                    shouldUpdatePosition={true}
                >
                    <Menu>{this.props.menuItems}</Menu>
                </Overlay>
                <Overlay
                    show={this.props.showApps}
                    placement={"bottom"}
                    container={this}
                    target={this.findAppsIcon}
                    shouldUpdatePosition={true}
                >
                    <AppsOverlay applications={this.props.applications} />
                </Overlay>
                {this.renderNotificationsOverlay()}
            </Row>
        );
    }

    private findAppsIcon = () => {
        return ReactDOM.findDOMNode(this.appsIcon);
    };

    private findMenuIcon = () => {
        return ReactDOM.findDOMNode(this.accountIcon);
    };

    private findNotificationsIcon = () => {
        return ReactDOM.findDOMNode(this.notificationsIcon);
    };
}



// WEBPACK FOOTER //
// ./src/Header.tsx